import styled from 'styled-components';
import { device } from "../device";

const LoginBtn = styled.button`
    display: flex;
    height: 30px;
    align-items: center;
    justify-content: center;
    padding: 0 24px;

    font-size: 14px;
    font-weight: 400;

    color: #fff;
    background: var(--dark-gray2);
    border: 1px solid var(--dark-gray2);
    border-radius: 15px;
    cursor: pointer;
    outline: 0;

    transition: background .15s ease-in-out, color .15s ease-in-out, border .15s ease-in-out; 

    will-change: opacity;
    &:hover {
        background: transparent;
        border-color: var(--dark-gray2);
        color: var(--brand);
    }
    @media ${device.lg} {
        .dark & {
            color: var(--brand);
            background: #fff;
            border-color: #fff;
            &:hover {
                background: transparent;
                border-color: #fff;
                color: #fff;
            }
        }
    }
`;

export default LoginBtn;